import { IGamesCategory, IGamesCategoryWidget } from '../../types';

export const getFirstNPictureGames = (
  preparedCategories: IGamesCategoryWidget[] = [],
  categories: IGamesCategory[] = [],
  firstGamesAmount = 3
) => {
  return preparedCategories.map((category) => {
    const matchingGameData = categories.find(
      (gameData) => gameData.id === category.id
    );

    if (matchingGameData) {
      const filteredGames = category.categoryGames.slice(0, firstGamesAmount);

      return {
        ...matchingGameData,
        categoryGames: filteredGames
      };
    }

    return category;
  });
};
